import React from "react";
import { Button, Column, Modal, toGrammaticalNumber } from "@hex-insights/core";
import { Student, StudentNameDescriptionAndImageFragment } from "../../../../../Utilities";
import { StudentsCondensedList } from "../../Icon";
import { StudentsListModal } from "../../ListModal";
import styles from "./styles.module.css";

export type StudentsCondensedListButtonProps = {
	students: (Pick<Student, "id"> & StudentNameDescriptionAndImageFragment)[];
};

export function StudentsCondensedListButton({ students }: StudentsCondensedListButtonProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button onClick={openModal} className={styles["condensed-list-button"]}>
				<Column justify="spaced-start" verticalSpacing="0.5rem">
					<span className={styles["condensed-list-button__label"]}>
						{toGrammaticalNumber("Student", students.length, true)}
					</span>
					<StudentsCondensedList students={students} iconSize={42} />
				</Column>
			</Button>

			<Modal.If condition={isModalOpen}>
				<StudentsListModal students={students} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}
